import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const configPath = <span className="font-bold">Configuración &gt; Horario de atención</span>
const officeHourLink = <Link to="/horarios-de-atencion">Ir a la sección Horario de atención</Link>

export const OfficeHourHintReceptionDesk = ({ canChangeOfficeHour, additionalConfig }) => {
  if (additionalConfig === 'required') {
    return canChangeOfficeHour ? (
      <>
        El horario de atención de la plantilla Mesa de partes ha sido definido por el Coordinador de tu entidad. Puedes
        editarlo en {configPath}. {officeHourLink}
      </>
    ) : (
      <>
        El horario de atención ha sido definido por el Coordinador de tu entidad en {configPath}. Si deseas editarlo,
        contáctalo.
      </>
    )
  }

  return canChangeOfficeHour ? (
    <>
      Valida o modifica el horario de atención de la Mesa de partes sugerido por el Coordinador de entidad, este debe
      ser de mínimo 8 horas continuas.
      <br />
      Puedes ver y editar su configuración en {configPath}. {officeHourLink}
    </>
  ) : (
    'Valida o modifica el horario de atención de la Mesa de partes sugerido por el Coordinador de entidad, este debe ser de mínimo 8 horas continuas.'
  )
}

export const OfficeHourHintOtherForm = ({ canChangeOfficeHour, additionalConfig }) => {
  if (additionalConfig === 'required') {
    return canChangeOfficeHour ? (
      <>
        El horario de atención ha sido definido por el Coordinador de tu entidad. Puedes editarlo en {configPath}.{' '}
        {officeHourLink}
      </>
    ) : (
      <>
        El horario de atención ha sido definido por el Coordinador de tu entidad en {configPath}. Si deseas editarlo,
        contáctalo.
      </>
    )
  }

  if (additionalConfig === 'suggested_required') {
    return canChangeOfficeHour ? (
      <>
        Valida o modifica el horario de atención sugerido por el Coordinador de entidad. Puedes ver y editar su
        configuración en {configPath}. {officeHourLink}
      </>
    ) : (
      'Valida o modifica el horario de atención sugerido por el Coordinador de entidad.'
    )
  }

  return canChangeOfficeHour ? (
    <>
      Opcionalmente, define un horario de atención para el formulario. Valida o modifica el horario sugerido por el
      Coordinador de entidad. Puedes ver y editar su configuración en {configPath}. {officeHourLink}
    </>
  ) : (
    'Opcionalmente, define un horario de atención para el formulario. Valida o modifica el horario sugerido por el Coordinador de entidad.'
  )
}

OfficeHourHintReceptionDesk.propTypes = {
  canChangeOfficeHour: PropTypes.bool,
  additionalConfig: PropTypes.string
}

OfficeHourHintOtherForm.propTypes = {
  canChangeOfficeHour: PropTypes.bool,
  additionalConfig: PropTypes.string
}
